import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import videojs from '!video.js';
import './videojs-overlay';
import './videojs-watermark';
import 'video.js/dist/video-js.css';
import muvikaAttrs from './../../attrs';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import { useCast } from './../../cast/CastProvider';
import IosVolumeControl from './../../services/volume';
import MuvikaService from './../../services/muvika';
import { Capacitor } from '@capacitor/core';
import TR from './../../Trans';
import TopBarPlayer from './TopBarPlayer';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import IntervalService from './../../services/intervals';
import sessionStore from '../../stores/session';
import playerStore from '../../stores/player';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import statusStore from './../../stores/status';
import newTracksStore from './../../stores/newTracks';
import timeoutsStore from './../../stores/timeouts';
import messageStore from '../../stores/message';
import ExternalViewCommands from './../../services/external';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import ExternalScreen from 'cordova-plugin-wkwebview-external-screen';
import navigationStore from '../../stores/navigation';
import musicPlayerStore from '../../stores/musicPlayer';

export const PreviewPlayer = (props) => {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const playQueue = performanceStore((state) => state.playQueue);
  const setOn = performanceStore((state) => state.setOn);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const isPlaying = playerStore((state) => state.isPlaying);
  const empty = playerStore((state) => state.empty);
  const isStopped = playerStore((state) => state.isStopped);
  const isFocused = playerStore((state) => state.isFocused);
  const getNextPerformance = performanceStore((state) => state.getNextPerformance);
  const currentTime = playerStore((state) => state.currentTime);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const setPreviewCurrentTime = playerStore((state) => state.setPreviewCurrentTime);
  const setFullScreen = playerStore((state) => state.setFullScreen);
  const streamUrl = playerStore((state) => state.streamUrl);
  const previewStreamUrl = playerStore((state) => state.previewStreamUrl);
  const isOn = performanceStore((state) => state.isOn);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const currentTrack = playerStore((state) => state.currentTrack);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const setCountdown = performanceStore((state) => state.setCountdown);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const setNextPerformance = performanceStore((state) => state.setNextPerformance);
  const setCurrentPerformance = performanceStore((state) => state.setCurrentPerformance);
  const currentPerformanceId = playerStore((state) => state.currentPerformanceId);
  const isInIosExternalScreen = playerStore((state) => state.isInIosExternalScreen);
  const currentPitch = playerStore((state) => state.currentPitch);
  const currentVersion = playerStore((state) => state.currentVersion);
  const setCurrentPitch = playerStore((state) => state.setCurrentPitch);
  const setCurrentVersion = playerStore((state) => state.setCurrentVersion);
  const isInExternalWindow = playerStore((state) => state.isInExternalWindow);
  const setIsInExternalWindow = playerStore((state) => state.setIsInExternalWindow);
  const isPlayListOn = performanceStore((state) => state.isOn);
  const isFullScreen = playerStore((state) => state.isFullScreen);
  const from = playerStore((state) => state.from);
  const setVolume = playerStore((state) => state.setVolume);
  const currentVolume = playerStore((state) => state.currentVolume);
  const trackEnded = playerStore((state) => state.trackEnded);
  const isAutoPlayOn = playerStore((state) => state.isAutoPlayOn);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const isTrackLogSent = playerStore((state) => state.isTrackLogSent);
  const setIsTrackLogSent = playerStore((state) => state.setIsTrackLogSent);
  const isFirstRender = navigationStore((state) => state.isPlayerFirstRender);
  const setIsFirstRender = navigationStore((state) => state.setIsPlayerFirstRender);
  const setAppStatus = statusStore((state) => state.setAppStatus);
  const setPlayerStatus = statusStore((state) => state.setPlayerStatus);
  const pitchRecog = playerStore((state) => state.pitchRecog);
  const isPitchEditable = playerStore((state) => state.isPitchEditable);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const isSwitching = playerStore((state) => state.isSwitching);
  const setCurrentBuffer = playerStore((state) => state.setCurrentBuffer);
  const isCasting = playerStore((state) => state.isCasting);
  const isRequestingCasting = playerStore((state) => state.isRequestingCasting);
  const setError = messageStore((state) => state.setError);
  const isWaitingCasting = playerStore((state) => state.isWaitingCasting);
  const setIsWaitingCasting = playerStore((state) => state.setIsWaitingCasting);
  const isBuffering = playerStore((state) => state.isBuffering);
  const setIsBuffering = playerStore((state) => state.setIsBuffering);
  const isFirstPerformance = performanceStore((state) => state.isFirstPerformance);
  const setIsFirstPerformance = performanceStore((state) => state.setIsFirstPerformance);
  const setIsReady = playerStore((state) => state.setIsReady);
  const settingsAutoPlay = settingsStore((state) => state.settings?.autoplay_enabled);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const isMusicPaused = musicPlayerStore((state) => state.isPaused);
  const isMusicPlaying = musicPlayerStore((state) => state.isPlaying);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);
  const setIsMusicReallyPaused = musicPlayerStore((state) => state.setIsMusicReallyPaused);

  const { chromecast } = useCast();

  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const options = props.options;

  let pausedPosition = 0;

  const showHomeUse = () => {
    if (timeoutsStore.getState().overlayShowHomeUse) {
      clearTimeout(timeoutsStore.getState().overlayShowHomeUse);
    }
    let timerSecs = (Math.floor(Math.random() * 200) + 60) * 1000;
    //console.log("timerSecs: " + timerSecs);
    let timer = setTimeout(function () {
      const player = playerRef.current;
      if (player) {
        player.trigger("hide_title");
        player.trigger("show_home_use_desc");
        hideHomeUse();
      }
    }, timerSecs);
    timeoutsStore.getState().setOverlayShowHomeUse(timer);
  };

  const hideHomeUse = () => {
    if (timeoutsStore.getState().overlayHideHomeUse) {
      clearTimeout(timeoutsStore.getState().overlayHideHomeUse);
    }
    let timer = setTimeout(function () {
      const player = playerRef.current;
      if (player) {
        player.trigger("show_title");
        player.trigger("hide_home_use_desc");
        showHomeUse();
      }
    }, 5000);
    timeoutsStore.getState().setOverlayHideHomeUse(timer);
  };

  const checkCurrentTimeOnExternalScreen = (player) => {
    ExternalViewCommands.getCurrentTime((result) => {
      let currentTimeEx = parseFloat(result);
      if (!isNaN(currentTimeEx)) {
        setCurrentTime(currentTimeEx);
      }
    });
    setTimeout(() => checkCurrentTimeOnExternalScreen(player), 1000);
  };

  const setOverlayCountdown = (countdown) => {
    const countdownEl = document.getElementById("muvika-preview-countdown");
    if (countdownEl) {
      if (countdown > 0) {
        countdownEl.textContent = countdown + "s";
      } else {
        countdownEl.textContent = "";
      }
    }
  };

  const getLocalCurrentPitch = (performance) => {
    if (performance.track.flags) {
      if (performance.track.flags.includes("voc_avail") && currentVersion === "vocal") {
        return 0;
      }
    }
    return performance.pitch;
  };

  const getLocalCurrentVersion = (performance) => {
    if (performance.track.flags) {
      if (performance.track.flags.includes("voc_avail") && currentVersion === "vocal") {
        return "vocal";
      }
    }
    return "normal";
  };

  const setPlayerCurrentTime = (time) => {
    /*     const player = playerRef.current;
        if (player) {
          player.currentTime(time);
        } */
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios' && !playerStore.getState().hasBeenPlayed) {
        console.log("setting current time ios");
        if (!playerStore.getState().isFullScreen) {
          playerStore.getState().setIosFrom(time >= 0 ? time : 0);
        }
      } else {
        console.log("setting current time standard");
        player.currentTime(time);
      }
    }
  };

  const endedFunc = (isAutoplayOn) => {
    setIsPlaying(false);
    setIsStopped(true);
    addPerformanceToHistory(sessionToken, currentPerformance);
    deletePerformance(sessionToken, currentPerformance.unique_id);
    console.log("ended");
    if (isAutoplayOn && isFocused) {
      console.log("is auto on: " + isAutoplayOn);
      setIsAutoPlayOn(true);
      let nextPerformance = getNextPerformance();
      if (nextPerformance) {
        setNextPerformance(nextPerformance);
        getStreamUrl(sessionToken, nextPerformance, nextPerformance.track, getLocalCurrentPitch(nextPerformance), getLocalCurrentVersion(nextPerformance), 0, false, true);
        setCountdown(settings.autoplay_secs);
        setOverlayCountdown(settings.autoplay_secs);
        let seconds = settings.autoplay_secs;
        let interval = setInterval(function () {
          let nextPerformanceLocal = nextPerformance;
          if (seconds > 0) {
            setCountdown(seconds);
            setOverlayCountdown(seconds);
            seconds = seconds - 1;
          } else {
            if (nextPerformanceLocal) {
              setCountdown(0);
              setOverlayCountdown(0);
              setCurrentTime(0);
              setNextPerformance(null);
              setIsPlaying(true);
              setIsStopped(false);
              clearInterval(interval);
            }
          }
        }, 1000);
        IntervalService.addInterval(interval, function () {
          setCountdown(0);
          setOverlayCountdown(0);
          setNextPerformance(null);
          clearInterval(interval);
        });
      } else {
        playerStore.getState().softReset();
        IntervalService.clearAllIntervals();
      }
    } else {
      setCurrentTime(0);
    }
  };

  const showPoster = (player) => {
    let posters = player.el().getElementsByClassName("vjs-poster");
    if (posters.length == 1) {
      posters[0].classList.remove("vjs-hidden");
      posters[0].innerHTML = "";
      posters[0].style.display = "block";
    }
  };

  const hidePoster = (player) => {
    let posters = player.el().getElementsByClassName("vjs-poster");
    if (posters.length == 1) {
      posters[0].style.display = "none";
    }
  };

  const showPlayButton = (player) => {
    let posters = player.el().getElementsByClassName("vjs-big-play-button");
    if (posters.length == 1) {
      posters[0].style.display = "block";
    }
  };

  const hidePlayButton = (player) => {
    let posters = player.el().getElementsByClassName("vjs-big-play-button");
    if (posters.length == 1) {
      posters[0].style.display = "none";
    }
  };

  const setPlayerVolume = (volume) => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        if (isMusicReallyPaused.isPaused) {
          IosVolumeControl.setDeviceVolume(volume);
        }
      } else {
        player.volume(volume);
      }
    }
  };

  const getPlayerVolume = () => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        return IosVolumeControl.getDeviceVolume();
      } else {
        return player.volume();
      }
    }
  };

  const initPlayer = () => {
    const videoElement = document.createElement("video-js");

    videoElement.classList.add('video-js');
    videoRef.current.appendChild(videoElement);
    const player = playerRef.current = videojs(videoElement, options, () => {
    });

    player.aspectRatio("16:9");
    setPlayerVolume(currentVolume.currentVolume);

    player.controlBar.removeChild(player.controlBar.getChild('PictureInPictureToggle'));
    showPoster(player);
    showPlayButton(player);
    if (muvikaAttrs.service === "muvika") {
      player.watermark({
        image: "./muvika-logo-gray-20.png",
        position: "top-left",
        xpos: 0,
        ypos: 0,
        xrepeat: 0,
        opacity: 100,
        clickable: false,
        className: 'vjs-watermark'
      });
    }

    if (props.isCustomer) {
      showHomeUse();
    }

    const origFocus = videoElement.focus;

    player.controlBar.getChild('playToggle').handleClick = () => {
      if (playerStore.getState().isReady) {
        playerStore.getState().setIsReady(false);
        if (player.paused()) {
          player.play();
        } else {
          player.pause();
        }
      }
    };

    // Override it
    videoElement.focus = function (options) {
      if (origFocus) {
        // Force preventScroll whenever focus is called
        origFocus.call(videoElement, { preventScroll: true });
      }
    };

    player.on('playing', function () {
      console.log("isPlaying");
      playerStore.getState().setHasBeenPlayed(true);
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      /* if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios" && playerStore.getState().iosFrom?.from) {
        playerStore.getState().setFrom(playerStore.getState().iosFrom.from);
        playerStore.getState().setIosFrom(null)
      } */
      if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
        setPlayerVolume(1);
      } else {
        setPlayerVolume(playerStore.getState().currentVolume.currentVolume);
      }
      hidePoster(player);
      console.log(playerStore.getState().isBuffering.isBuffering);
      if (!document.hidden) {
        if (!playerStore.getState().isBuffering.isBuffering) {
          hidePoster(player);
          setIsPlaying(true);
          if (!playerStore.getState().iosPlayPauseHackOn) {
            setIsStopped(false);
          }
          setPlayerStatus(sessionToken, "streaming");
          IntervalService.clearAllIntervals();
          player.trigger("hide_title");
        } else {
          console.log("test pausing 1");
          player.pause();
        }
      }
    });

    player.on('pause', function () {
      console.log("isPaused");
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      console.log(playerStore.getState().isBuffering.isBuffering);
      if (!document.hidden && !playerStore.getState().isBuffering.isBuffering && player.currentTime() > 2 && !(Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') && !isInIosExternalScreen) {
        console.log("setting is playing false");
        setIsPlaying(false);
        setPlayerStatus(sessionToken, "paused");
        player.trigger("show_title");
      }
    });

    player.on('fullscreenchange', function () {
      let isPlayerFullscreen = player.isFullscreen();
      player.controls(isPlayerFullscreen);
      setFullScreen(isPlayerFullscreen);
      if (isPlayerFullscreen) {
        setAppStatus(sessionToken, "fullscreen");
      } else {
        setAppStatus(sessionToken, "mainwindow");
      }
    });

    player.on('progress', function () {
      let buffEnd = player.bufferedEnd();
      setCurrentBuffer(buffEnd / player.duration());
    });

    if (props.isExternal) {
      player.fill(true);
    } else {
      player.fill(false);
    }

    player.playsinline(true);
    player.reset();

    if (Capacitor.getPlatform() === 'android') {
      AndroidExternalScreen.addListener('currentTime', (result) => {
        console.log('android currentTime: ' + result.value);
        if (!isNaN(result.value)) {
          playerStore.getState().setIsSwitching(false);
          playerStore.getState().setIsReady(true);
          playerStore.getState().setCurrentTime(result.value);
        }
      });
      AndroidExternalScreen.addListener('isBuffering', (result) => {
        console.log('android isBuffering: ' + result.value);
        playerStore.getState().setIsBuffering(result.value);
      });
    }
  };

  useEffect(() => {
    if (!playerRef.current) {
      initPlayer();
      initEmptyOverlay();
      checkPlayQueue();
    } else {
    }
  });

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (isFocused) {
        showPlayButton(player);
      } else {
        hidePlayButton(player);
      }
    }
  }, [isFocused]);

  const checkPlayQueue = () => {
    if (playQueue) {
      const player = playerRef.current;
      if (player) {
        if (playQueue.items.length == 0) {
          player.trigger("playqueue_empty");
          player.trigger("hide_title");
          player.trigger("hide_home_use_desc");
          clearInterval(timeoutsStore.getState().overlayShowHomeUse);
          clearInterval(timeoutsStore.getState().overlayHideHomeUse);
        } else {
          player.trigger("playqueue_populated");
          if (props.isCustomer) {
            showHomeUse();
          }
        }
      }
    }
  };

  useEffect(() => {
    checkPlayQueue();
  }, [playQueue]);

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  const [isVolumeSetFromSettings, setVolumeSetFromSettings] = useState(false);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (settings) {
        player.off('ended');
        player.one('ended', () => endedFunc(settings.autoplay_enabled));
        if (!isVolumeSetFromSettings) {
          if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
            if (settings.volume) {
              if (currentVolume.currentVolume == 0) {
                setVolumeSetFromSettings(true);
                setVolume(settings.volume / 100);
                setPlayerVolume(settings.volume / 100);
              }
            }
          } else {
            setPlayerVolume(1);
          }
        }
      }
    }
  }, [settings]);

  useEffect(() => {
    if (!isFirstRender) {
      if (settingsAutoPlay && (isStopped.isStopped || (playerStore.getState().currentTime == 0 && !isPlaying.isPlaying))) {
        if (isFirstPerformance) {
          setIsFirstPerformance(null);
        } else {
          if (isFocused) {
            runCountdown();
          }
        }
      } else if (!settingsAutoPlay) {
        IntervalService.clearAllIntervals();
      }
    }
    setIsAutoPlayOn(settingsAutoPlay);
  }, [settingsAutoPlay]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("buffering: " + isBuffering.isBuffering);
      if (isBuffering.isBuffering) {
        console.log("buffer pause");
        //player.pause();
      } else {
        console.log("stopped buffering");
        if (playerStore.getState().isPlaying.isPlaying) {
          player.play();
        } else {
          console.log("test pausing 2");
          player.pause();
        }
      }
    }
  }, [isBuffering]);

  useEffect(() => {
    const player = playerRef.current;
    if (player && currentTrack) {
      if (currentPerformance.track.flags) {
        if (currentPerformance.track.flags.includes("voc_avail")) {
          console.log("currentVersion", currentVersion);
          showPoster(player);
          let savedCurrentTime = playerStore.getState().currentTime;
          let versionVersion = currentVersion;
          let versionPitch = getLocalCurrentPitch(currentPerformance);
          if (currentTrack.flags) {
            if (currentTrack.flags.includes("voc_avail")) {
              if (versionVersion === "vocal") {
                versionPitch = 0;
              }
            } else {
              if (versionVersion === "vocal") {
                versionVersion = "normal";
              }
            }
          } else {
            versionVersion = "normal";
          }
          getStreamUrl(sessionToken, currentPerformance, currentTrack, versionPitch, versionVersion, savedCurrentTime, isPlaying.isPlaying, false);
        }
      }
    }
  }, [currentVersion]);

  useEffect(() => {
    if (pitchRecog) {
      const player = playerRef.current;
      console.log("test get stream url r", pitchRecog.currentPitch, isPitchEditable);
      if (player && currentTrack && isPitchEditable) {
        console.log("set currentPitch", pitchRecog.currentPitch);
        showPoster(player);
        let savedCurrentTime = playerStore.getState().currentTime;
        let versionVersion = currentVersion;
        let versionPitch = getLocalCurrentPitch(currentPerformance);
        if (currentTrack.flags) {
          if (currentTrack.flags.includes("voc_avail")) {
            if (versionVersion === "vocal") {
              versionPitch = 0;
            }
          } else {
            if (versionVersion === "vocal") {
              versionVersion = "normal";
            }
          }
        } else {
          versionVersion = "normal";
        }
        console.log("test get stream url", versionVersion, versionPitch);
        getStreamUrl(sessionToken, currentPerformance, currentTrack, versionPitch, versionVersion, savedCurrentTime, isPlaying.isPlaying, false);
      }
    }
  }, [pitchRecog]);

  useEffect(() => {
    if (isFocused) {
      IntervalService.clearAllIntervals();
    }
  }, [isFocused]);

  const runCountdown = () => {
    console.log("running countdown");
    if (currentPerformance && !nextPerformance && isFocused) {
      IntervalService.clearAllIntervals();
      setNextPerformance(currentPerformance);
      getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, false, true);
      setCountdown(settings.autoplay_secs);
      setOverlayCountdown(settings.autoplay_secs);
      let seconds = settings.autoplay_secs;
      let interval = setInterval(function () {
        let nextPerformanceLocal = currentPerformance;
        if (seconds > 0) {
          setCountdown(seconds);
          setOverlayCountdown(seconds);
          seconds = seconds - 1;
        } else {
          if (nextPerformanceLocal) {
            setCountdown(0);
            setOverlayCountdown(0);
            setCurrentTime(0);
            setNextPerformance(null);
            setIsPlaying(true);
            setIsStopped(false);
            clearInterval(interval);
          }
        }
      }, 1000);
      IntervalService.addInterval(interval, function () {
        setCountdown(0);
        setOverlayCountdown(0);
        setNextPerformance(null);
        clearInterval(interval);
      });
    }
  };

  const initExternalOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<div class="home_use_only_overlay external">' + TR.cm_karaoke_for_home_use_only + '</div>',
          start: 'show_home_use_desc',
          end: 'hide_home_use_desc',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  const initOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<span>' + currentPerformance.profile.name + " - " + currentPerformance.track.title + ' <span id="muvika-preview-countdown"></span></span>',
          start: 'show_title',
          end: 'hide_title',
          align: 'top',
          showBackground: false
        }, {
          content: '<div class="home_use_only_overlay">' + TR.cm_karaoke_for_home_use_only + '</div>',
          start: 'show_home_use_desc',
          end: 'hide_home_use_desc',
          align: 'top',
          showBackground: false
        }, {
          content: TR.cm_playlist_is_empty,
          start: 'playqueue_empty',
          end: 'playqueue_populated',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  const initEmptyOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<div>' + TR.cm_playlist_is_empty + '</div>',
          start: 'playqueue_empty',
          end: 'playqueue_populated',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  const stopCCmedia = () => {
    if (isCasting) {
      if (!Capacitor.isNativePlatform()) {
        chromecast.off();
        chromecast.stop();
      } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
        Chromecast.stop()
          .then(res => {
            console.log("stopCCMedia", res);
          })
          .catch(err => {
            console.log("stopCCMedia err", err);
          });
      }
    }
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      chromecast.off();
      player.off('timeupdate', function () { });
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      if (currentPerformance) {
        if (props.isExternal) {
          initExternalOverlay();
        } else {
          initOverlay();
        }
        player.trigger("show_title");
        if (currentPerformanceId) {
          if (currentPerformanceId != currentPerformance.unique_id) {
            showPoster(player);
            console.log("previewstream loaded");
            if (settings.autoplay_enabled && isAutoPlayOn.isAutoPlayOn) {
              console.log("start countdown");
              runCountdown();
            } else {
              getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, isPlaying.isPlaying, true);
            }
          } else {
            if (currentPerformance.track.track_id === currentTrack?.track_id) {
              console.log("previewstream loaded");
              hidePoster(player);
              if (currentPitch !== currentPerformance.pitch) {
                setCurrentPitch(currentPerformance.pitch);
              }
            } else {
              getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, isPlaying.isPlaying, true);
            }
          }
        } else {
          console.log("previewstream loaded");
          showPoster(player);
          if (settings.autoplay_enabled && isAutoPlayOn.isAutoPlayOn && !isFirstPerformance) {
            console.log("start countdown");
            runCountdown();
          } else {
            setIsFirstPerformance(null);
            getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, isPlaying.isPlaying, true);
          }
        }
      } else {
        IntervalService.clearAllIntervals();
        setCountdown(0);
        setOverlayCountdown(0);
        setNextPerformance(null);
        player.src();
        stopCCmedia();
        playerStore.getState().softReset();
        showPoster(player);
        player.bigPlayButton.hide();
        //player.bigPlayButton.show();
      }
    }
  }, [currentPerformance]);

  const goToCasting = (player) => {
    if (chromecast.connected) {
      if (!isWaitingCasting) {
        setIsWaitingCasting(true);
        console.log("try to cast");
        chromecast.cast(streamUrl, { title: currentPerformance ? currentPerformance.track.artist + " - " + currentPerformance.track.title : "" })
          .then(() => {
            console.log("chromecast casting", chromecast.on);
            setIsWaitingCasting(false);
            chromecast.seek(currentTime);
            if (playerStore.getState().isPlaying.isPlaying) {
              console.log("x chromecast play");
              chromecast.play();
            } else {
              console.log("x chromecast pause");
              chromecast.pause();
            }
            chromecast.on('buffering', (result) => {
              console.log("chromecast buffering");
              console.log(chromecast);
            });
            chromecast.on('idle', () => {
              console.log("chromecast idle");
            });
            chromecast.on('timeupdate', () => {
              if (playerStore.getState().isStopped.isStopped) {
                chromecast.seek(0);
                console.log("x chromecast pause");
                chromecast.pause();
              } else {
                console.log("chromecast time" + playerStore.getState().currentTime, chromecast.time);
                playerStore.getState().setCurrentTime(chromecast.time);
                console.log("chromecast", playerStore.getState().isPlaying.isPlaying, chromecast.state);
                if (playerStore.getState().isPlaying.isPlaying) {
                  if (chromecast._mediaSession) {
                    if (!chromecast._mediaSession.activeTrackIds) {
                      setError(sessionToken, 0, TR.cm_chromecast_casting_error);
                      chromecast.off();
                      chromecast.disconnect();
                    }
                  }
                  if (chromecast.state === "paused") {
                    console.log("x chromecast play");
                    chromecast.play();
                  }
                } else {
                  if (chromecast.state === "playing") {
                    console.log("x chromecast pause");
                    chromecast.pause();
                  }
                }
              }
            });

          })
          .catch((err) => {
            console.log("chromecast", err);
            setIsWaitingCasting(false);
          });
      }
    }
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (currentPerformance) {
        //console.log("currentTime on player " + currentTime);
        //console.log("currentTimes: " + currentTime + " " + player.currentTime());
        //console.log(currentPerformance.track.length.split(':').reduce((acc, time) => (60 * acc) + +time) - currentTime);
        if (currentTime > 0) {
          if (Math.abs(currentPerformance.track.length.split(':').reduce((acc, time) => (60 * acc) + +time) - currentTime) > 10) {
            if (Math.abs(currentTime - player.currentTime()) > 0.6) {
              if (isPlaying.isPlaying) {
                console.log("x chromecast play()")
                player.play();
                player.currentTime(currentTime);
              }
            }
          }
        }
      }
    }
  }, [currentTime]);

  const ccInitWeb = (player) => {
    player.src(previewStreamUrl);
    player.currentTime(currentTime);
    setPlayerVolume(currentVolume.currentVolume);
    if (isCasting) {
      goToCasting(player);
    };
    player.off('ended');
    player.one('ended', () => endedFunc(isPlayListOn));
    player.off('timeupdate');
    player.on('timeupdate', function () {
      playerStore.getState().setIosFrom(null);
      if (playerStore.getState().isCasting && chromecast.connected) {
        if (playerStore.getState().isPlaying.isPlaying) {
          if (chromecast._mediaSession) {
            if (!chromecast._mediaSession.activeTrackIds) {
              setError(sessionToken, 0, TR.cm_chromecast_casting_error);
              chromecast.off();
              chromecast.disconnect();
            }
          }
          console.log("chromecast", playerStore.getState().isPlaying.isPlaying, chromecast.state);
          if (chromecast.state === "paused") {
            //chromecast.play();
          }
        } else {
          if (chromecast.state === "playing") {
            //chromecast.pause();
          }
        }
      }
      setPreviewCurrentTime(player.currentTime());
      //setCurrentTime(player.currentTime());
      if (performanceStore.getState().currentPerformance) {
        console.log(playerStore.getState().isTrackLogSent + " " + performanceStore.getState().currentPerformance.unique_id);
        if (!playerStore.getState().isTrackLogSent && player.currentTime() >= 30 && !playerStore.getState().isSwitching && !playerStore.getState().isStopped.isStopped) {
          console.log("send track log set " + player.currentTime());
          console.log(playerStore.getState().isTrackLogSent + " " + performanceStore.getState().currentPerformance.unique_id);
          playerStore.getState().setIsTrackLogSent(performanceStore.getState().currentPerformance.unique_id);
          MuvikaService.setTrackLog(sessionToken, playerStore.getState().currentTrack, getLocalCurrentPitch(performanceStore.getState().currentPerformance), performanceStore.getState().currentPerformance.profile.id, playerStore.getState().isCasting ? "chromecast" : "external");
        }
      }
    });
    player.on('canplay', function () {
      if (currentTime == 0) {
        player.currentTime(currentTime);
        if (playerStore.getState().isTrackLogSent !== performanceStore.getState().currentPerformance.unique_id) {
          playerStore.getState().setIsTrackLogSent(null);
        }
        player.off('canplay');
      }
    });
  };

  const ccAndroid = (player) => {
    player.src(previewStreamUrl);
    player.currentTime(currentTime);
    if (isCasting) {
      Chromecast.loadMedia({ contentId: streamUrl, metadata: { title: currentPerformance ? currentPerformance.track.artist + " - " + currentPerformance.track.title : "" } })
        .then(result => {
          Chromecast.addListener("PROGRESS", (result) => {
            console.log("progress: " + result);
            setCurrentTime(result.currentTime);
          });
          Chromecast.seek({ from: currentTime });
          if (playerStore.getState().isPlaying.isPlaying) {
            Chromecast.play();
          } else {
            Chromecast.pause();
          }
        });
    };
    player.off('ended');
    player.one('ended', () => endedFunc(isPlayListOn));
    player.off('timeupdate');
    player.on('timeupdate', function () {
      playerStore.getState().setIosFrom(null);
      if (performanceStore.getState().currentPerformance) {
        if (!playerStore.getState().isTrackLogSent && player.currentTime() >= 30 && !playerStore.getState().isSwitching && !playerStore.getState().isStopped.isStopped) {
          console.log("send track log set " + player.currentTime());
          playerStore.getState().setIsTrackLogSent(performanceStore.getState().currentPerformance.unique_id);
          MuvikaService.setTrackLog(sessionToken, playerStore.getState().currentTrack, getLocalCurrentPitch(performanceStore.getState().currentPerformance), performanceStore.getState().currentPerformance.profile.id, playerStore.getState().isCasting ? "chromecast" : "external");
        }
      }
    });
    player.on('canplay', function () {
      if (currentTime == 0) {
        player.currentTime(currentTime);
        if (playerStore.getState().isTrackLogSent !== performanceStore.getState().currentPerformance.unique_id) {
          playerStore.getState().setIsTrackLogSent(null);
        }
        player.off('canplay');
      }
    });
  };

  const ccIos = (player) => {
    player.src(previewStreamUrl);
    playerStore.getState().setHasBeenPlayed(false);
    //player.currentTime(currentTime);
    player.off('ended');
    player.one('ended', () => endedFunc(isPlayListOn));
    player.off('timeupdate');
    player.on('timeupdate', function () {
      if (playerStore.getState().iosFrom?.from && playerStore.getState().iosFrom?.from != 0) {
        console.log("set iosFrom from", playerStore.getState().iosFrom?.from);
        //player.currentTime(playerStore.getState().iosFrom.from);
        playerStore.getState().setIosFrom(null);
      }
      if (performanceStore.getState().currentPerformance && playerStore.getState().currentTrack) {
        if (!playerStore.getState().isTrackLogSent && player.currentTime() >= 30 && !playerStore.getState().isSwitching && !playerStore.getState().isStopped.isStopped) {
          console.log("send track log set " + player.currentTime());
          playerStore.getState().setIsTrackLogSent(performanceStore.getState().currentPerformance.unique_id);
          MuvikaService.setTrackLog(sessionToken, playerStore.getState().currentTrack, getLocalCurrentPitch(performanceStore.getState().currentPerformance), performanceStore.getState().currentPerformance.profile.id, playerStore.getState().isCasting ? "chromecast" : "external");
        }
      }
    });
    player.on('canplay', function () {
      if (currentTime == 0) {
        player.currentTime(currentTime);
        if (playerStore.getState().isTrackLogSent !== performanceStore.getState().currentPerformance.unique_id) {
          playerStore.getState().setIsTrackLogSent(null);
        }
        player.off('canplay');
      }
    });
  };

  useEffect(() => {
    console.log("previewstream streamURl", previewStreamUrl);
    const player = playerRef.current;
    if (player) {
      if (previewStreamUrl !== "") {
        if (!Capacitor.isNativePlatform()) {
          ccInitWeb(player);
        } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
          ccAndroid(player);
        } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
          ccIos(player);
        }
      } else {
        IntervalService.clearAllIntervals();
        setCountdown(0);
        setOverlayCountdown(0);
        setNextPerformance(null);
        player.src();
        playerStore.getState().softReset();
        showPoster(player);
        player.bigPlayButton.hide();
        //player.bigPlayButton.show();
      }
    } else {
      IntervalService.clearAllIntervals();
      setCountdown(0);
      setOverlayCountdown(0);
      setNextPerformance(null);
      player.src();
      showPoster(player);
      player.bigPlayButton.hide();
      //player.bigPlayButton.show();
    }
  }, [previewStreamUrl]);

  /*   useEffect(() => { 
      const player = playerRef.current;
      if (player) {
        if (isCasting) {
          chromecast.cast(streamUrl, {title: currentPerformance ? currentPerformance.track.artist + " - " + currentPerformance.track.title : ""})
            .then(() => { 
              chromecast.pause();
              chromecast.seek(currentTime);
              chromecast.on('error', (e) => {
      console.log(e)
                if(e === "session_error"){
                  chromecast.off();
                  chromecast.disconnect();
                }
              });
              chromecast.on('timeupdate', () => { 
                if(isPlaying.isPlaying){
                  if (Math.abs(player.currentTime() - chromecast.time) > 1) {
                    player.currentTime(chromecast.time);
                  }
                }
              });
            });
        }
      }
    }, [isCasting]); */

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!isPlayListOn) {
        //player.reset();
      }
    }
  }, [isPlayListOn]);

  useEffect(() => {
    const player = playerRef.current;
    if (player && previewStreamUrl !== "") {
      if (isPlaying.isPlaying && !isSwitching) {
        if (isMusicReallyPaused.isPaused) {
          setIsReady(true);
          player.play();
        }
        if (isCasting && currentPerformance) {
          if (!Capacitor.isNativePlatform()) {
            if (chromecast.connected) {
              setIsReady(true);
              console.log("x chromecast play")
              chromecast.play();
            }
          } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
            setIsReady(true);
            Chromecast.play();
          }
        }
      } else {
        player.bigPlayButton.show();
        console.log("test pausing 3");
        player.pause();
        if (isCasting && currentPerformance) {
          if (!Capacitor.isNativePlatform()) {
            if (chromecast.connected) {
              setIsReady(true);
              console.log("x chromecast pause")
              chromecast.pause();
            }
          } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
            setIsReady(true);
            Chromecast.pause();
          }
        }
      }
    }
  }, [isPlaying]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("isPlayingPlayer", isMusicReallyPaused.isPaused);
      if (isPlaying.isPlaying && !isSwitching && isMusicReallyPaused.isPaused) {
        player.play();
      }
    }
  }, [isMusicReallyPaused]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      setPlayerCurrentTime(from.from);
      if (isCasting && currentPerformance) {
        if (!Capacitor.isNativePlatform()) {
          if (chromecast.connected) {
            chromecast.seek(from.from);
          }
        } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
          Chromecast.seek({ from: from.from });
        }
      }
    }
  }, [from]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      player.isFullscreen(isFullScreen);
      if (isFullScreen) {
        player.requestFullscreen();
      }
    }
  }, [isFullScreen]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      let settingVolume = currentVolume.currentVolume;
      if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
        settingVolume = 1;
      }
      if (!currentVolume.doNotPropagate) {
        setPlayerVolume(settingVolume);
      }
      if (isCasting && currentPerformance) {
        if (!Capacitor.isNativePlatform()) {
          if (chromecast.connected) {
            chromecast.volume(settingVolume);
          }
        } else {
          Chromecast.volume({ level: settingVolume });
        }
      }
    }
  }, [currentVolume]);

  useEffect(() => {
    const player = playerRef.current;
    if (player && previewStreamUrl !== "") {
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      if (isStopped.isStopped) {
        playerStore.getState().setIsTrackLogSent(null);
        showPoster(player);
        player.trigger("stop");
        setPlayerStatus(sessionToken, "stopped");
        player.bigPlayButton.show();
      } else {
        hidePoster(player);
        player.bigPlayButton.hide();
      }
    }
  }, [isStopped]);

  return (
    <div style={props.style} data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default PreviewPlayer;